import './PageJournalComptable.css';


function PageJournalComptable() {
    return (
        <h1>PageJournalComptable</h1>
    );
}

export default PageJournalComptable

